export const factoryList = (state, rootState) => {
	return state.factoryList;
}

export const packageList = (state, rootState) => {
	return state.packageList;
}

export const vehicleList = (state, rootState) => {
	return state.vehicleList;
}

export const productConfig = (state, rootState) => {
	return state.productConfig;
}

export const transportMatrix = (state, rootState) => {
	return state.transportMatrix;
}

export const transportStructure = (state, rootState) => {
	return state.transportStructure;
}

export const objFactoryEdit = (state, rootState) => {
	return state.objFactoryEdit;
}

export const objPackageEdit = (state, rootState) => {
	return state.objPackageEdit;
}

export const objVehicleEdit = (state, rootState) => {
	return state.objVehicleEdit;
}

export const runSave = (state, rootState) => {
	return state.runSave;
}

export const objPackageEditProducts = (state, rootState) => {
	return state.objPackageEditProducts;
}

export const objPackageAdd = (state, rootState) => {
	return state.objPackageAdd;
}

export const objPackageAddProducts = (state, rootState) => {
	return state.objPackageAddProducts;
}

export const objVehicleEditMatrix = (state, rootState) => {
	return state.objVehicleEditMatrix;
}

export const objVehicleEditSelectedPackages = (state, rootState) => {
	return state.objVehicleEditSelectedPackages;
}

export const objVehicleEditPackages = (state, rootState) => {
	return state.objVehicleEditPackages;
}

export const objVehicleAddMatrix = (state, rootState) => {
	return state.objVehicleAddMatrix;
}

export const objVehicleAddSelectedPackages = (state, rootState) => {
	return state.objVehicleAddSelectedPackages;
}

export const packagesLoaded = (state, payload) => {
	return state.packagesLoaded;
}

export const vehiclesLoaded = (state, payload) => {
	return state.vehiclesLoaded;
}

